import type { TranslatedValue } from "@swo/storefront";
import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { CheckoutHeadline } from "../../checkout-page-layout/CheckoutComponent/shared/CheckoutHeadline";
import { css } from "@emotion/react";
import { T } from "../../../../components/T";

export const OrderHeadline: ReactTFC<{ orderNumber: string; orderLabel: TranslatedValue }> = props => {
  return (
    <CheckoutHeadline
      className={"js-order-headline"}
      css={css`
        margin-top: 0;
      `}
    >
      <T>{props.orderLabel}</T> #{props.orderNumber}
    </CheckoutHeadline>
  );
};
